<!--基础排班-->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <!-- <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">设置</span>
      </div>
    </div> -->
    <!-- <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container2" style="margin-top: 10px">
        <div class="top-row">
          <span>A班时间:</span>
          <el-time-picker style="width: 200px; margin-left: 10px; margin-right: 10px;"
                          v-model="apTime.amTime[0]"
                          format="HH:mm"
                          value-format="HH:mm"
                          :picker-options="{
      selectableRange: '00:00:00- 23:59:59'
    }"
                          placeholder="起始">
          </el-time-picker>
          <span>--</span>
          <el-time-picker style="width: 200px; margin-left: 10px;"
                          v-model="apTime.amTime[1]"
                          format="HH:mm"
                          value-format="HH:mm"
                          :picker-options="{
      selectableRange: '00:00:00- 23:59:59'
    }"
                          placeholder="结束">
          </el-time-picker>
        </div>
        <div class="top-row">
          <span>B班时间:</span>
          <el-time-picker style="width: 200px;margin-left: 10px; margin-right: 10px;"
                          v-model="apTime.pmTime[0]"
                          format="HH:mm"
                          value-format="HH:mm"
                          :picker-options="{selectableRange: '00:00:00- 23:59:59'}"
                          placeholder="起始"/>
          <span>--</span>
          <el-time-picker style="width: 200px;margin-left: 10px; margin-right: 10px;"
                          v-model="apTime.pmTime[1]"
                          format="HH:mm"
                          value-format="HH:mm"

                          :picker-options="{selectableRange: '00:00:00- 23:59:59',}"
                          placeholder="结束"/>
        </div>
      </div>
    </el-card> -->
    <!-- <div class="titleContainer">
      <div style="margin-right: 30px;">
        <span>A班时间:</span>
        <el-time-picker style="width: 200px; margin-left: 10px; margin-right: 10px;"
                          v-model="apTime.amTime[0]"
                          format="HH:mm"
                          value-format="HH:mm"
                          :picker-options="{
      selectableRange: '00:00:00- 23:59:59'
    }"
                          placeholder="起始">
          </el-time-picker>
          <span>--</span>
          <el-time-picker style="width: 200px; margin-left: 10px;"
                          v-model="apTime.amTime[1]"
                          format="HH:mm"
                          value-format="HH:mm"
                          :picker-options="{
      selectableRange: '00:00:00- 23:59:59'
    }"
                          placeholder="结束">
          </el-time-picker>
      </div>
      <div style="margin-right: 30px;">
        <span>B班时间:</span>
        <el-time-picker style="width: 200px;margin-left: 10px; margin-right: 10px;"
                          v-model="apTime.pmTime[0]"
                          format="HH:mm"
                          value-format="HH:mm"
                          :picker-options="{selectableRange: '00:00:00- 23:59:59'}"
                          placeholder="起始"/>
          <span>--</span>
          <el-time-picker style="width: 200px;margin-left: 10px; margin-right: 10px;"
                          v-model="apTime.pmTime[1]"
                          format="HH:mm"
                          value-format="HH:mm"

                          :picker-options="{selectableRange: '00:00:00- 23:59:59',}"
                          placeholder="结束"/>
      </div>
      <div v-if="false">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh"
          @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
          询</el-button>
      </div>
    </div> -->
    <!---->
    <div class="buttonPermission">
      <div class="future">
        <div :class="pitchUp == index ? 'future-btn' : 'future-btm'" v-for="(v, index) in pitchList"
          @click="clcikPitchUp(index)" :style="index == 1 ? 'margin-right: 0px' : 'margin-right: 15px'">
          {{ v }}
        </div>
      </div>
      <div v-if="pitchUp == 0" style="display: flex;">
        <div style="display: flex;align-items: center;margin-right: 20px;">
          <el-switch style="margin-right: 5px;" v-model="inAutoRelaease" @change="changeAutoe" />
          <img style="width: 16px; height: 16px;margin-right: 5px;" src="@/statics/imgs/vip.png" alt="" />
          <div style="color:#303133 ;font-size: 14px;">自动发布课程</div>
        </div>

        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickDialog(1)">设置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickDialog(2)">添加排班</el-button>
      </div>
    </div>
    <div>
      <scheling-base-time v-if="pitchUp == 0" :key="cnsTimer" ref="SchelingBaseTimes" :cns="cns"></scheling-base-time>
      <scheling-base-release-records v-if="pitchUp == 1" :day="weekTime"
        :key="releaseRecordsTimer"></scheling-base-release-records>
      <store-rest v-if="pitchUp == 2" ref="refrerRest" :lesson-template-id="lessonTemplateId"
        :key="refrerRest"></store-rest>
    </div>
    <sche-reference v-show="false" ref="refScheReference" :key="referenceTimer" :times="times"></sche-reference>

    <!-- <el-tabs type="card" v-model="activeName" @tab-click="handleChangeTab" style="margin-top: 15px;">
      <el-tab-pane label="基础排班" name="pane-reference">
        <sche-reference ref="refScheReference" :key="referenceTimer" :times="times"></sche-reference>
      </el-tab-pane>
      <el-tab-pane label="课程发布记录" name="release-records">
        <scheling-base-release-records :day="weekTime" :key="releaseRecordsTimer"></scheling-base-release-records>
      </el-tab-pane>
      <el-tab-pane label="预约基础配置" name="second">
        <scheling-base-time :key="cnsTimer" ref="SchelingBaseTime" :cns="cns"></scheling-base-time>
      </el-tab-pane> -->
    <!--<el-tab-pane label="基础课程设置" name="third">-->
    <!--<scheling-base-lesson-setting :lesson-name="lessonName" :key="restsTimer" ref="SchelingBaseLessonSetting"></scheling-base-lesson-setting>-->
    <!--</el-tab-pane>-->
    <!--<el-tab-pane label="门店设置" name="forth">-->
    <!--<scheling-store-setting :key="restsTimer" :rests="rests" ref="SchelingStoreSetting"></scheling-store-setting>-->
    <!--</el-tab-pane>-->
    <!-- <el-tab-pane label="门店设置" name="forth">
        <store-rest ref="refrerRest" :lesson-template-id="lessonTemplateId" :key="refrerRest"></store-rest>
      </el-tab-pane>
    </el-tabs> -->
    <!-- <el-card v-if="activeName != 'forth' && activeName != 'second'" class="operate-container"
      style="width: 100%; margin-top: 15px;" shadow="never">
      <el-button @click="onQlWeekData">{{ weekName }}</el-button>
      <el-button v-if="activeName == 'pane-reference'" type="primary" size="medium" class="operator-btn"
        icon="el-icon-folder-checked" @click="onSaveCur">保存</el-button>
    </el-card> -->
    <el-card v-if="pitchUp == 1" class="operate-container" style="width: 100%; border: 0px;" shadow="never">
      <el-button v-if="activeName == 'pane-reference'" type="primary" size="medium" class="operator-btn"
        icon="el-icon-folder-checked" @click="onQlWeekData">{{ weekName }}</el-button>
    </el-card>
    <!-- 设置 -->
    <el-dialog title="设置时间" :visible.sync="visibleDlgSetLessonName" width="50%">
      <el-form :model="formst" label-width="100px">
        <div style="display: flex;" v-for="(v, index) in formst.lessonsCourseList" :key="index">
          <el-form-item label="业务名称">
            <el-input disabled v-model="v.lessonServiceName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="重命名">
            <el-input v-model="v.lessonName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="时间设置(分钟)" label-width="120px">
            <!-- <el-input v-model="v.classTime" autocomplete="off" ></el-input> -->
            <el-input-number v-model="v.classTime" :min="1" :max="1000"></el-input-number>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="dialogForm(1)">保 存</el-button>
        <el-button @click="visibleDlgSetLessonName = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 添加排班 -->
    <el-dialog title="添加排班" :visible.sync="addSchedule" width="40%">
      <el-form :model="form" label-width="100px">
        <div style="display: flex;">
          <el-form-item label="选择业务">
            <el-select v-model="form.serviceId" placeholder="请选择" @change="change">
              <el-option v-for="item in listByStoreList" :key="item.serviceId" :label="item.lessonName"
                :value="item.serviceId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间(时：分)">
            <el-time-picker style="width: 150px" v-model="form.time" format="HH:mm" value-format="HHmm"
              :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="上课时间">
            </el-time-picker>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="周一:" style="width: 45%;">
            <div style="display: flex;">
              <div>{{ this.form.serviceName }}</div>
              <el-input style="width: 60%;margin-left: 10px;" v-model="form.one" autocomplete="off"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="周二:" style="width: 45%;">
            <div style="display: flex;">
              <div>{{ this.form.serviceName }}</div>
              <el-input style="width: 60%;margin-left: 10px;" v-model="form.two" autocomplete="off"></el-input>
            </div>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="周三:" style="width: 45%;">
            <div style="display: flex;">
              <div>{{ this.form.serviceName }}</div>
              <el-input style="width: 60%;margin-left: 10px;" v-model="form.three" autocomplete="off"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="周四:" style="width: 45%;">
            <div style="display: flex;">
              <div>{{ this.form.serviceName }}</div>
              <el-input style="width: 60%;margin-left: 10px;" v-model="form.four" autocomplete="off"></el-input>
            </div>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="周五:" style="width: 45%;">
            <div style="display: flex;">
              <div>{{ this.form.serviceName }}</div>
              <el-input style="width: 60%;margin-left: 10px;" v-model="form.five" autocomplete="off"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="周六:" style="width: 45%;">
            <div style="display: flex;">
              <div>{{ this.form.serviceName }}</div>
              <el-input style="width: 60%;margin-left: 10px;" v-model="form.six" autocomplete="off"></el-input>
            </div>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="周日:" style="width: 45%;">
            <div style="display: flex;">
              <div>{{ this.form.serviceName }}</div>
              <el-input style="width: 60%;margin-left: 10px;" v-model="form.day" autocomplete="off"></el-input>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="dialogForm(2)">保 存</el-button>
        <el-button @click="addSchedule = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import globaldata from "../../../utils/globaldata";
import { qlScheduleBs, saveScheduleBs } from "../../../api/scheduleTimeTemplate";
import commonUtils from "../../../utils/commonUtils";
import timeUtils from "../../../utils/timeUtils";
import messageUtils from "../../../utils/messageUtils";
import SchelingBaseTime from "./components/SchelingBaseTime";
import SchelingBaseLessonSetting from "./components/SchelingBaseLessonSetting";
import SchelingStoreSetting from "./components/SchelingStoreSetting";
import { releaseBsWeekLesson, lessonsCourseArranging, lessonsCourseAdd, listByStoreFontId } from "../../../api/StoreReleaseLesson";
import StoreRest from "../component/StoreRest";
import { getStoreRestDay } from "../../../api/StoreSetting";
import enumsUtil from "../../../utils/enumsUtil";
import ScheReference from "../component/ScheReference";
import SchelingBaseReleaseRecords from "./components/SchelingBaseReleaseRecords";

export default {
  components: {
    SchelingBaseReleaseRecords,
    ScheReference, StoreRest, SchelingStoreSetting, SchelingBaseLessonSetting, SchelingBaseTime
  },
  data() {
    return {
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }],
      value: '',
      pitchUp: 0,
      lessonName: '',
      value1: new Date(2016, 9, 10, 18, 40),
      inAutoRelaease: false, //是否自动发布
      visibleDlgSetLessonName: false, // 设置
      addSchedule: false, // 添加排班
      form: {
        serviceId: '',
        time: '',
        serviceName: '',
        cn: [],
        one: '',
        two: '',
        three: '',
        four: '',
        five: '',
        six: '',
        day: ''
      },
      pitchList: ['A预约设置', 'A课程发布记录', '门店设置'],
      curTime: [],
      apTime: {
        amTime: ["10:30", "10:40"],
        pmTime: ["16:80", "19:40"],
      },
      listByStoreList: [],
      cnsTimer: "",
      restsTimer: "",
      activeName: 'pane-reference',

      refrerRest: "",
      lessonTemplateId: null,
      id: null,
      weekTime: "",
      allWorker: [],
      tableTitleData: {
        swTeacher: "泳师",
        time: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],

      },
      refreshTimer: "",
      tableData: [
      ],
      formst: {
        lessonsCourseList: [],

      },
      cns: [],
      rests: [],
      restsTimer: "",
      lessonName: '',

      times: [], //员工一周排班
      referenceTimer: "",

      weekName: "查询下周",
      isThisWeek: false, //是否是本周

      releaseRecordsTimer: "",
      isVip: globaldata.getAdminStore().isVip,

    }
  },
  created() {
    this.lessonTemplateId = enumsUtil.lessonTemplateIdBS();
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    this.weekTime = new Date().getTime();
    this.curTime[0] = "本周"

  },
  methods: {
    // 打开  dialog
    clickDialog(val) {
      if (val == 1) {
        //查询A排课业务
        this.lessonsCourse()
      } else if (val == 2) {
        this.form = {
          serviceId: '',
          time: '',
          serviceName: '',
          cn: [],
          one: '',
          two: '',
          three: '',
          four: '',
          five: '',
          six: '',
          day: ''
        }
        this.listByStore()
      }
    },
    //查询A排课业务
    lessonsCourse() {
      lessonsCourseArranging({ storeFontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        if (res.code == 20000) {
          this.formst.lessonsCourseList = res.data
          this.visibleDlgSetLessonName = true
        }
      })
    },
    // 关闭  dialog
    dialogForm(val) {
      if (val == 1) {
        //A排课时间保存
        this.lessons()
      } else if (val == 2) {
        this.clickForm()
        this.addSchedule = false
      }
    },
    //自动发布课程
    changeAutoe(val) {
      if (this.isVip == 0) {
        this.inAutoRelaease = false
        this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
        return
      }
      // console.log(val,'=-==========')
      // return
      this.$refs['SchelingBaseTimes'].changeAutoRelease(val)
    },
    clickForm() {
      // console.log(this.form,'=============')
      // return
      this.form.serviceId = JSON.stringify(this.form.serviceId)
      this.form.cn.push(Number(this.form.one))
      this.form.cn.push(Number(this.form.two))
      this.form.cn.push(Number(this.form.three))
      this.form.cn.push(Number(this.form.four))
      this.form.cn.push(Number(this.form.five))
      this.form.cn.push(Number(this.form.six))
      this.form.cn.push(Number(this.form.day))
      this.$refs['SchelingBaseTimes'].Scheli(this.form)
    },
    //A排课时间保存
    lessons() {
      // let createTime
      // let date = new Date()
      // var Y = date.getFullYear() + '-';
      // var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      // var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      // createTime = Y + M + D
      this.formst.lessonsCourseList.forEach((item) => {
        item.serviceId = item.lessonServiceId
        item.storeFontId = globaldata.getAdminStore().storeFrontId
        // item.createTime = createTime
      })
      lessonsCourseAdd({ list: this.formst.lessonsCourseList }).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "保存成功");
          this.visibleDlgSetLessonName = false
        }
      })
    },
    change(val) {
      //  console.log(val,'==========')
      this.listByStoreList.forEach((item) => {
        if (val == item.serviceId) {
          this.form.serviceName = item.lessonName
        }
      })
    },
    ///查询A业务
    listByStore() {
      listByStoreFontId({ storeFontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        if (res.code == 20000) {
          this.listByStoreList = res.data
          this.addSchedule = true
        }
      })
    },
    // 选中周几
    clcikPitchUp(index) {
      this.pitchUp = index
      if (this.pitchUp == 2) {
        this.getStoreRestDay();
      }
    },
    changeAutoRelease(val) {
      let param = {
        id: globaldata.getAdminStore().storeFrontId,
        auto: val,
      }
      setAutoRelease(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data == true) {
          messageUtils.successMsg(this, response.message)
        } else {
          messageUtils.errorMsg(this, response.message)
        }
      })
    },
    // 重置
    handleResetSearch() {

    },
    // 查询
    onBtnSearch() {

    },
    refreshData(data) {
      this.resetWorkerSche();
      let nowTime = new Date().getTime();

      this.id = data.id;
      this.curTime[0] = timeUtils.transDay(data.weekTime);
      this.apTime = {
        amTime: ["00:00", "12:00"],
        pmTime: ["12:00", "23:59"],
      };
      if (!commonUtils.isStringNull(data.apTime)) {
        this.apTime = JSON.parse(data.apTime);
      }
      let times = [];
      if (!commonUtils.isStringNull(data.times)) {
        times = JSON.parse(data.times);
      }
      this.times = times;
      this.referenceTimer = new Date().getTime();
      // for (let i = 0;i< times.length;++i){
      //   let dayIndex  = times[i].dayIndex;
      //   let workersAm  =  times[i].workers.am;
      //   if (!commonUtils.isObjectNull(workersAm)){
      //     for (let j = 0;j< workersAm.length;++j){
      //       let tableWorker = this.getTableDataWorker(workersAm[j]);
      //       if (!commonUtils.isObjectNull(tableWorker)){
      //         tableWorker.checked[dayIndex][0] = true;
      //       }
      //     }
      //   }
      //   let workersPm  =  times[i].workers.pm;
      //   if (!commonUtils.isObjectNull(workersPm)){
      //     for (let j = 0;j< workersPm.length;++j){
      //       let tableWorker= this.getTableDataWorker(workersPm[j]);
      //       if (!commonUtils.isObjectNull(tableWorker)){
      //         tableWorker.checked[dayIndex][1] = true;
      //       }
      //     }
      //   }
      //
      //
      // };
      if (!commonUtils.isStringNull(data.cnTimes)) {
        this.cns = data.cnTimes;
      } else {
        this.cns = []
      }
      if (!commonUtils.isStringNull(data.closeLesson)) {
        this.rests = data.closeLesson;
      } else {
        this.rests = []
      }
      this.lessonName = data.lessonName
      this.cnsTimer = nowTime;
      this.restsTimer = nowTime;

    },
    getStoreWorkersInfo(workers) {
      this.qlScheduleBs();
      this.tableData = [];
      this.allWorker = workers;
      this.resetWorkerSche();

    },
    //重置所有人排班
    resetWorkerSche() {
      //先将所有的都置为没有排班
      this.tableData = [];
      for (let i = 0; i < this.allWorker.length; ++i) {
        let worker = {
          id: this.allWorker[i].id,
          name: this.allWorker[i].name,
          checked: [[false, false], [false, false], [false, false], [false, false], [false, false], [false, false], [false, false]]
        }
        this.tableData.push(worker);
      }
    },

    getTableDataWorker(id) {
      for (let i = 0; i < this.tableData.length; ++i) {
        if (this.tableData[i].id == id) {
          return this.tableData[i];
        }
      }
    },

    qlScheduleBs() {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        weekTime: this.weekTime,
      }
      qlScheduleBs(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.successMsg(this, "当前周没有排班数据");
          return;
        }
        this.isThisWeek = !this.isThisWeek;
        if (this.isThisWeek) {
          this.weekName = "查询下一周"
        } else {
          this.weekName = "查询本周"
        }
        this.refreshData(data);
      })
    },

    //保存当前
    onSaveCur() {

      this.onSave();
    },
    onSaveNextWeek() {
      let weekTime = this.weekTime;
      weekTime += (7 * 24 * 3600000)
      this.weekTime = weekTime;

      this.onSave();
    },
    onQlnextWeek() {
      this.weekTime = this.weekTime + (7 * 24 * 3600000)
      this.qlScheduleBs();
    },
    onQlLastWeek() {
      this.weekTime = this.weekTime - (7 * 24 * 3600000)
      this.qlScheduleBs();
    },
    onQlWeekData() {
      if (this.isThisWeek) {
        //如果是当前周,需要查询下一周
        this.onQlnextWeek();

      } else {
        //如果不是本周 需要查询本周
        this.onQlLastWeek();

      }

      this.releaseRecordsTimer = new Date().getTime();

    },
    onSave() {
      const loading = this.myLoading();
      // let cnTimes = this.$refs['SchelingBaseTime'].onGetBaseTime();
      let times = this.$refs['refScheReference'].getScheTimes();



      let param = {
        id: this.id,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        weekTime: this.weekTime,
        times: JSON.stringify(times),
        apTime: JSON.stringify(this.apTime),
        cnTimes: "",
        lessonName: "",
        closeLesson: ""
      }

      // //计算每周哪些人上班
      // let weekData = [];
      // for (let dayIndex  =0;dayIndex< this.tableTitleData.time.length;++dayIndex) {
      //   //dayIndex 周几
      //   let weekItem = {
      //     dayIndex:dayIndex,
      //     workers :[]
      //   }
      //   let workerStr = {
      //     am:[],
      //     pm:[]
      //   };
      //   for (let i = 0;i< this.tableData.length;++i){
      //     let worker = this.tableData[i];
      //     if (worker.checked[dayIndex][0] == true){
      //       workerStr.am.push(worker.id);
      //     }
      //     if (worker.checked[dayIndex][1] == true){
      //       workerStr.pm.push(worker.id);
      //     }
      //   }
      //   weekItem.workers = workerStr;
      //   weekData.push(weekItem);
      // }

      saveScheduleBs(param).then(response => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, "保存成功");
        this.refreshData(date);
        loading.close();
      })

    },

    checkClick(index, checkIndex, ap) {
      let check = this.tableData[index].checked[checkIndex][ap];
      this.tableData[index].checked[checkIndex][ap] = (!check);
      this.refreshTimer = new Date().getTime();

    },

    onClickReleaseLesson() {
      const loading = this.myLoading();
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "123456",
        scheTemplateId: this.id,

      }
      releaseBsWeekLesson(param).then(response => {
        loading.close();
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, response.message);

      })
    },
    handleChangeTab(tab) {
      if (this.activeName == "forth") {
        this.getStoreRestDay();

      }

    },
    getStoreRestDay() {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        lessonTemplateId: enumsUtil.lessonTemplateIdBS(),
      }

      getStoreRestDay(param).then(response => {
        let data = response.data;
        if (data != null) {
          this.$refs['refrerRest'].refreshData(data);
        }
      })
    }
  },

}
</script>
<style scoped>
.future {
  background: #ECF3FD;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 5px;
}

.future-btn {
  /* width: 100px;
  height: 40px; */
  padding: 10px 17px;
  background: #0E6FB8;
  border-radius: 8px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  text-align: center;
  /* line-height: 40px; */
  /* margin-right: 15px; */
}

.future-btm {
  /* width: 100px;
  height: 40px; */
  padding: 10px 17px;
  /* line-height: 40px; */
  background: #ECF3FD;
  border-radius: 8px;
  font-size: 14px;
  color: #74798C;
  cursor: pointer;
  text-align: center;
  /* margin-right: 15px; */
}

.titleContainer {
  background-color: #ffffff;
  padding: 30px 40px;
  width: 100%;
  border-radius: 8px;
  display: flex;
}

.buttonPermission {
  width: 100%;
  background-color: #ffffff;
  padding: 14px 24px;
  border-radius: 8px 8px 0 0;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}

/deep/ .el-tabs__item {
  height: 36px;
  color: #0e6eba;
  background: #cedef5;
  margin-right: 10px;
  border-radius: 4px;
  line-height: 36px;
  /* 卡片阴影 */
  box-shadow: 0px 0px 16px 4px rgba(238, 56, 35, 0.09);
}

/deep/ .el-tabs__item.is-active {
  color: #ffffff;
  text-align: center;
  background: linear-gradient(120.93deg, #1270b8 3.98%, #5aaeee 100%);
}

/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__nav-wrap::after {
  display: none;
}

.top-row {
  width: 40%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/my-store/sw-teacher-scheduling-bs/index.vue